import { FormAutoSaverService } from './services/FormAutoSaverService';
import { API } from './api/API';
import { Auth0Service } from './services/Auth0Service';
import { LoggingService } from './services/LoggingService';

type RisenHopeEnvironment = {
  /** The current API. */
  api: API;
  /** Available external services */
  services: {
    auth: Auth0Service;
    logger: LoggingService;
    formAutoSaver: FormAutoSaverService;
  };
  // ...
};

/** This value holds the actual environment object. */
let _currentEnvironment: RisenHopeEnvironment | undefined = undefined;

/** Exposes the current `GopherEnvironment` via `current()`. */
const Environment = {
  /** Returns the current environment. */
  current(): RisenHopeEnvironment {
    return { ..._currentEnvironment! };
  },

  /** Sets the current environment. Call as early as possible during startup. */
  set(environment: RisenHopeEnvironment) {
    if (_currentEnvironment === undefined) {
      _currentEnvironment = environment;
    } else {
      // TODO: force a crash?
    }
  },
};

Object.freeze(Environment);
export { Environment };
